import { z } from 'zod';
import { emailRegex } from '../../../../utils/regular-expressions';

export const GroupTemplateBasicInfoSchema = z.object({
  groupTemplateName: z.string().min(1, 'Name is required.'),
  groupTemplateDesc: z.string(),
  primaryLanguage: z.string(),
  allowWebPosting: z.boolean(),
  includeInGlobalAddressList: z.boolean(),
  isArchived: z.boolean(),
});

export const GroupTemplateSettingsFieldsSchema = z.object({
  membersCanPostAsTheGroup: z.boolean(),
  messageModerationLevel: z.string(),
  sendMessageDenyNotification: z.boolean(),
  defaultMessageDenyNotificationText: z.string(),
  spamModerationLevel: z.string(),
  replyTo: z.string(),
  customReplyTo: z.string(),
});

export const GroupTemplatePermissionsSchema = z.object({
  whoCanViewGroup: z.string(),
  whoCanPostMessage: z.string(),
  whoCanViewMembership: z.string(),
  whoCanModerateMembers: z.string(),
  whoCanModerateContent: z.string(),
  whoCanContactOwner: z.string(),
  whoCanAssistContent: z.string(),
  whoCanLeaveGroup: z.string(),
  whoCanDiscoverGroup: z.string(),
  whoCanJoin: z.string(),
  allowExternalMembers: z.boolean(),
});

export const GroupTemplateSecuritySchema = z.object({
  securityQuery: z.string().optional(),
});

export const GroupTemplateFormSchema = z
  .object({
    archiveOnly: z.boolean(),
    createdDate: z.number(),
  })
  .merge(GroupTemplateBasicInfoSchema)
  .merge(GroupTemplateSettingsFieldsSchema)
  .merge(GroupTemplatePermissionsSchema)
  .merge(GroupTemplateSecuritySchema)
  .superRefine((data, ctx) => {
    if (
      data.replyTo === 'REPLY_TO_CUSTOM' &&
      !emailRegex.test(data.customReplyTo)
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Not a valid email.',
        path: ['customReplyTo'],
      });
    }
  });
